export interface IPropertyProspectionModel {
    TypeOfRoofText: string;
    RoofCoveringText: string;
    RoofConditionText: string;
    WindowGlazingText: string;
    WindowFrameText: string;
    KitchenText: string;
    HeatingBText: string;
    ElectricityStateText: string;
    SourceContact: number;
}

export class PropertyProspectionModel implements IPropertyProspectionModel {
    TypeOfRoofText: string;
    RoofCoveringText: string;
    RoofConditionText: string;
    WindowGlazingText: string;
    WindowFrameText: string;
    KitchenText: string;
    HeatingBText: string;
    ElectricityStateText: string;
    SourceContact: number;

    constructor() {
        this.ElectricityStateText = null;
        this.HeatingBText = null;
        this.KitchenText = null;
        this.RoofConditionText = null;
        this.RoofCoveringText = null;
        this.TypeOfRoofText = null;
        this.WindowFrameText = null;
        this.WindowGlazingText = null;
        this.SourceContact = null;
    }
}